import { backdropClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import COLORS from '../../styles/COLORS';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: COLORS.green,
    // color: "#224880",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: '#ececec',
    // color: "#00aa7e",
    // borderRadius: '2px',
    // letterSpacing: '0.5px',
    // border: '1px solid #00aa7e',
    // marginTop: '7px',
    // fontSize: '12px',
    // fontStyle: 'italic',
    // fontFamily: 'NotoSans-Medium',
    // fontWeight: 500,

    
    // border: '1px solid #00aa7e',
    // backgroundColor: "#e6fff8",
    // color: "#00aa7e",
    fontFamily: 'NotoSans-Medium',
    border: `1px solid ${COLORS.blue}`,
    backgroundColor: COLORS.lightBlue,
    color: COLORS.blue,

  },
}));

export default StyledTooltip